import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ActTransactionComp from "./Component/ActTransactionComp"


const ActTransaction =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ActTransactionComp />
        </div>
        <Footer />
        </>
    )
}

export default ActTransaction